import { render, staticRenderFns } from "./modelRZ.vue?vue&type=template&id=65d346d8"
import script from "./modelRZ.vue?vue&type=script&lang=js"
export * from "./modelRZ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports